module.exports = {
      id: "login-google-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#login-google",
      toString: function () {
        return this.url;
      }
    }